
import { Vue, Component } from "vue-property-decorator";
import LayoutLoading from "@/components/shared/layout/FblLayoutLoading.vue";
import { LoginOutput } from "@fubonlife/tacallindiy-core-axios-sdk";

@Component({
	components: {
		LayoutLoading,
	},
})
export default class DispatchEmptyPage extends Vue {
	/**
	 * Hook
	 */
	created() {
		var token = this.$route.query.token as string;
		console.log('token',token)
		if (token) {
			this.dispatch(token);
		} else {
			this.$router.replace({ name: "Error04" });
		}
	}

	async dispatch(token: string) {
		this.$DispatchControllerApi.loginDispatchUsingGET1(token)
			.then(res => {
				if (res.status === 200) {
					let result: LoginOutput = JSON.parse(JSON.stringify(res.data));
					if (result.status === 'SUCCESS') {
						const me = {
							token: token,
							callInNumber: result['callInNumber']
						}
						this.$user.signIn(result['accessToken'], me)
						this.$router.replace({ name: "InsureEmptyRouter" });
					} else {
						switch (result.statusCode) {
							case '01012002': // 取得登入檢核型態失敗
								this.$router.replace({ name: "Error04" });
								break;
							case '03007002': // 簡訊發送時間逾時
								this.$router.replace({ name: "Error05" });
								break;
							case '03009002': // TOKEN已有對應保單號碼
								this.$router.replace({ name: "ApplicationCompleted" });
								break;
							case '01012003': // 查無此Token對應的登入檢核型態
								this.$router.replace({ name: "Error04" });
								break;
							case '03008002': // 400DB未運作
								this.$router.replace({ name: "ErrorMaintenance" });
								break;
						}
					}
				} else {
					this.$router.replace({ name: "Error04" });
				}
			})
	}

}
